import { FuseLoadable } from '@fuse';

export const VerfiyEmailConfig = {
  settings: {
    layout: {
      style: 'layout1',
      config: {
        scroll: 'content',
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false
        },
        leftSidePanel: {
          display: false
        },
        rightSidePanel: {
          display: false
        }
      }
    },
    theme: {
      main: 'defaultDark',
      navbar: 'mainThemeDark',
      toolbar: 'mainThemeLight',
      footer: 'mainThemeDark'
    }
  },
  routes: [
    {
      path: '/verifyemail/:email/:hash',
      component: FuseLoadable({
        loader: () => import('./VerifyEmail')
      })
    },
    {
      path: '/verifyemail',
      component: FuseLoadable({
        loader: () => import('./VerifyEmail')
      })
    },
    {
      path: '/ConfirmEmail/:email/:hash',
      component: FuseLoadable({
        loader: () => import('./VerifyEmail')
      })
    }
  ]
};
